var $ = jQuery.noConflict();

(function($) {
  'use strict';

  var globalVariables = {
    $body: $('body'),
    $navMain: $('#nav-main')
  };

  var appFunction = {
    common: '*',
    browserFunction: '*',
    headerFunction: $('#header-main'),
    accordionFunction: $('.accordion'),
    contactForm: $('.contact-form'),
    scrollingFunction: '*',
    modaalFunction: '*',
    slickCarouselFunction: $('.carousel'),
    componentMultiUpload: $('#acf-upload-area'),
    pageEngagement: $('.page-engagement'),
    templateLight: $('.model-tpl-light'),
    connexionFunction: $('.js-btn--client-connected'),
    newsletterInscription: '*',
    filterActus: $('[data-post-type="actus"] .filtre__list, [data-post-type="actus-voile"] .filtre__list'),
    filterMediasVoile: $('[data-post-type="medias"] .filtre__list'),
    blockArgumentsFunction: $('.block-arguments'),
    videoFunction: $('.bandeau__video'),
    anchorsFunction: '*'
  };

  $.each(appFunction, function(funcName, condition) {
    if (
      (typeof condition === 'string' && $('body').hasClass(condition)) ||
      (typeof condition === 'object' && condition.length) ||
      (typeof condition === 'string' && condition === '*')
    ) {
      try {
        window[funcName].call(this, globalVariables);
      } catch (e) {
        console.error(funcName + ' is not a function');
        console.log(e);
      }
    } else if (typeof window[funcName] !== 'function') {
      console.warn(funcName + ' is not a function');
    }
  });
})(jQuery);
